module.exports = __webpack_public_path__ + "static/media/icon_conductor.988a681c.png";